import { render, staticRenderFns } from "./addbiddingplan.vue?vue&type=template&id=63943eb0&scoped=true"
import script from "./addbiddingplan.vue?vue&type=script&lang=js"
export * from "./addbiddingplan.vue?vue&type=script&lang=js"
import style0 from "./addbiddingplan.vue?vue&type=style&index=0&id=63943eb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63943eb0",
  null
  
)

export default component.exports